import {AppModel} from 'app/client/models/AppModel';
import {DocPageModel} from 'app/client/models/DocPageModel';

export function buildHomeBanners(_app: AppModel) {
  return null;
}

export function buildDocumentBanners(_docPageModel: DocPageModel) {
  return null;
}
